/* Private product properties; no browser events are sent to TrackingTC. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.start(root);
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var TYPES = ['gclid', 'gbraid', 'wbraid'];
  var STORAGE = 'ttc_click_identifier_v1';
  var DENIAL = 'ttc_marketing_denied_v1';
  var CONSENT = '_ttc_marketing_consent';
  function valid(value) { return typeof value === 'string' && /^[A-Za-z0-9_-]{1,512}$/.test(value); }
  function fromUrl(url, now) {
    var params = new URL(url).searchParams;
    for (var type of TYPES) {
      var value = params.get(type);
      if (valid(value)) return { type: type, value: value, captured_at: new Date(now).toISOString() };
    }
    return null;
  }
  function properties(click, consent) {
    var result = { _ttc_gclid: '', _ttc_gbraid: '', _ttc_wbraid: '', _ttc_marketing_consent: '' };
    if (consent === 'explicit_denied') result[CONSENT] = consent;
    else if (click && TYPES.indexOf(click.type) !== -1 && valid(click.value)) {
      result['_ttc_' + click.type] = click.value;
      result[CONSENT] = consent;
    }
    return result;
  }
  function mergeProperties(existing, desired) {
    var result = Object.assign({}, existing || {});
    Object.keys(desired).forEach(function (key) {
      if (desired[key]) result[key] = desired[key];
      else delete result[key];
    });
    return result;
  }
  function different(a, b) {
    a = a || {}; b = b || {};
    return Object.keys(a).length !== Object.keys(b).length || Object.keys(a).some(function (k) { return a[k] !== b[k]; });
  }
  function fillForms(doc, desired) {
    doc.querySelectorAll('form[action]').forEach(function (form) {
      var path;
      try { var url = new URL(form.action, doc.baseURI); if (url.origin !== new URL(doc.baseURI).origin) return; path = url.pathname; } catch (_) { return; }
      if (!/\/cart\/add(?:\.js)?\/?$/.test(path)) return;
      Object.keys(desired).forEach(function (key) {
        var name = 'properties[' + key + ']';
        var inputs = form.querySelectorAll('input[name="' + name + '"]');
        if (!desired[key]) {
          inputs.forEach(function (input) { input.remove(); });
          return;
        }
        var input = inputs[0];
        if (!input) { input = doc.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
        for (var i = 1; i < inputs.length; i++) inputs[i].remove();
        if (input.value !== desired[key]) input.value = desired[key];
      });
    });
  }
  // Work from the fresh response each time: property updates can change keys and merge lines.
  async function reconcile(fetcher, base, getDesired, isCurrent) {
    var response = await fetcher(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('cart_read_failed');
    var cart = await response.json();
    for (var attempt = 0; attempt < 100 && isCurrent(); attempt++) {
      var desired = getDesired();
      var item = cart.items.find(function (line) { return different(line.properties, mergeProperties(line.properties, desired)); });
      if (!item) return;
      response = await fetcher(base + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        // Omit quantity: never restore a quantity that the customer has since changed.
        body: JSON.stringify({ id: item.key, properties: mergeProperties(item.properties, desired) })
      });
      if (!response.ok) throw new Error('cart_update_failed');
      cart = await response.json();
    }
  }
  function start(win) {
    if (!win || win.__ttcClickIdentifiersStarted) return;
    win.__ttcClickIdentifiersStarted = true;
    var doc = win.document, click = null, consent = 'unknown', revision = 0, busy = false, pending = false;
    var base = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    function read(key) { try { return win.localStorage.getItem(key); } catch (_) { return null; } }
    function write(key, value) { try { if (value === null) win.localStorage.removeItem(key); else win.localStorage.setItem(key, value); } catch (_) {} }
    function loadClick() {
      try { var saved = JSON.parse(read(STORAGE)); return saved && TYPES.indexOf(saved.type) !== -1 && valid(saved.value) ? saved : null; } catch (_) { return null; }
    }
    click = loadClick();
    if (read(DENIAL) === '1') consent = 'explicit_denied';
    function desired() { return properties(click, consent); }
    async function syncCart() {
      pending = true;
      if (busy) return;
      busy = true;
      while (pending) {
        pending = false;
        var current = revision;
        try { await reconcile(async function (url, options) {
          var controller = new win.AbortController();
          var timeout = win.setTimeout(function () { controller.abort(); }, 8000);
          try { return await win.fetch(url, Object.assign({}, options, { signal: controller.signal })); }
          finally { win.clearTimeout(timeout); }
        }, base, desired, function () { return current === revision; }); }
        catch (_) { /* Retry on next consent/storage/cart event; never block a purchase. */ }
      }
      busy = false;
    }
    function refresh(captureUrl, forceDenial) {
      var privacy = win.Shopify && win.Shopify.customerPrivacy;
      if (!forceDenial && privacy && privacy.currentVisitorConsent) {
        try {
          var marketing = privacy.currentVisitorConsent().marketing;
          if (marketing === 'no') consent = 'explicit_denied';
          else if (marketing === 'yes') consent = 'explicit_allowed';
          else if (marketing === '' && consent !== 'explicit_denied') consent = 'unanswered_allowed';
        } catch (_) {}
      }
      if (consent === 'explicit_denied') { click = null; write(STORAGE, null); write(DENIAL, '1'); }
      else {
        if (consent === 'explicit_allowed') write(DENIAL, null);
        var found = captureUrl ? fromUrl(win.location.href, Date.now()) : null;
        if (found) { click = found; write(STORAGE, JSON.stringify(click)); }
      }
      revision++;
      fillForms(doc, desired());
      // With neither click nor refusal there is no marketing state to propagate.
      if (click || consent === 'explicit_denied') syncCart();
    }
    refresh(true);
    var observer = new win.MutationObserver(function () { fillForms(doc, desired()); });
    observer.observe(doc.documentElement, { childList: true, subtree: true });
    // Fill synchronously before theme AJAX handlers serialize a newly inserted quick-shop form.
    doc.addEventListener('click', function () { fillForms(doc, desired()); }, true);
    doc.addEventListener('submit', function () { fillForms(doc, desired()); }, true);
    doc.addEventListener('visitorConsentCollected', function () { refresh(false); });
    doc.addEventListener('shopify:section:load', function () { fillForms(doc, desired()); });
    win.addEventListener('storage', function (event) {
      if (event.key !== STORAGE && event.key !== DENIAL && event.key !== null) return;
      click = loadClick();
      if (read(DENIAL) === '1') consent = 'explicit_denied';
      refresh(false, read(DENIAL) === '1');
    });
    win.addEventListener('pageshow', function () { refresh(false); });
    // Turbo uses jQuery AJAX to add products. Reconcile after add, including quick shop.
    function attachAjax() {
      if (win.jQuery) win.jQuery(doc).on('ajaxComplete.ttcClickIdentifiers', function (_event, _xhr, settings) {
        if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(settings.url || '') && (click || consent === 'explicit_denied')) syncCart();
      });
    }
    if (doc.readyState === 'complete') attachAjax(); else doc.addEventListener('DOMContentLoaded', attachAjax, { once: true });
    if (win.Shopify && win.Shopify.loadFeatures) win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) refresh(false); });
  }
  return { fromUrl: fromUrl, properties: properties, mergeProperties: mergeProperties, fillForms: fillForms, reconcile: reconcile, start: start };
}));
